module.exports = __webpack_public_path__ + "img/img.9e951e68.png";